import { createStyles, makeStyles } from '@material-ui/core/styles';
import { INFO_GREEN } from 'constants/colors';
export default makeStyles(theme => {
  return createStyles({
    vehicleInfoRoot: {
      width: '100%',
      background: INFO_GREEN,
      padding: theme.spacing(2),
      margin: theme.spacing(2, 0)
    },
    vehicleInfo: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridRowGap: theme.spacing(2),
      columnGap: theme.spacing(3)
    },
    title: {
      marginLeft: theme.spacing(1)
    },
    column: {
      display: 'flex',
      flexDirection: 'column'
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(2)
    }
  });
});